export default __webpack_public_path__ + "static/media/telescope.ee06cc71.svg";